import { render, staticRenderFns } from "./CountChart.vue?vue&type=template&id=590658e6&scoped=true&"
import script from "./CountChart.vue?vue&type=script&lang=ts&"
export * from "./CountChart.vue?vue&type=script&lang=ts&"
import style0 from "./CountChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CountChart.vue?vue&type=style&index=1&id=590658e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590658e6",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
